import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { ActionCreators } from './asyncTasks';

export const DownloadStaticFileButton: React.FC<React.PropsWithChildren<{ filename: string }>> = ({
    filename,
    children,
}) => {
    const dispatch = useDispatch();
    const downloadStatic = useCallback(() => {
        ActionCreators.downloadStatic(filename)(dispatch).catch((v) => v);
    }, []);
    return (
        <div style={{ display: 'flex', flexDirection: 'column' }}>
            <div className="mt-2">
                <a onClick={downloadStatic}>{children}</a>
            </div>
        </div>
    );
};

export const DownloadAdditionalFileButton: React.FC<React.PropsWithChildren<{ fileKey: string }>> = ({
    fileKey,
    children,
}) => {
    const dispatch = useDispatch();
    const downloadFile = useCallback(() => {
        ActionCreators.downloadAdditionalFile(fileKey)(dispatch).catch((v) => v);
    }, []);
    return (
        <div style={{ display: 'flex', flexDirection: 'column' }}>
            <div className="mt-2">
                <a onClick={downloadFile}>{children}</a>
            </div>
        </div>
    );
};
